// AboutUs.js
import React, { useEffect, useState } from "react";
import { storage } from "../firebase"; // Adjust the import path as needed
import { ref, listAll, getDownloadURL } from "firebase/storage";
import './AboutUs.css'; // Import the CSS file for styling

const AboutUs = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const folderRefs = [
          "BIM/",
          "Certificates/",
          "Guide/",
          "about us/",
          "career/",
          "home/",
          "news/",
          "projects/"
        ];

        const itemsList = await Promise.all(
          folderRefs.map(async (folder) => {
            const folderRef = ref(storage, folder);
            const folderContents = await listAll(folderRef);
            const files = await Promise.all(
              folderContents.items.map(async (file) => {
                const url = await getDownloadURL(file);
                return { name: file.name, url, size: file.size, type: file.contentType };
              })
            );

            // Check if the folder is "projects" to fetch subfolders
            if (folder === "projects/") {
              const subfolderFiles = await fetchSubfolders(folderRef);
              return { folder, files: [...files, ...subfolderFiles] };
            }

            return { folder, files };
          })
        );

        setItems(itemsList);
      } catch (error) {
        console.error("Error fetching items: ", error);
      }
    };

    // Function to recursively fetch images from subfolders
    const fetchSubfolders = async (folderRef) => {
      const subfolderContents = await listAll(folderRef);
      const allFiles = await Promise.all(
        subfolderContents.prefixes.map(async (subfolder) => {
          const subfolderFiles = await listAll(subfolder);
          return await Promise.all(
            subfolderFiles.items.map(async (file) => {
              const url = await getDownloadURL(file);
              return { name: file.name, url, size: file.size, type: file.contentType };
            })
          );
        })
      );
      return allFiles.flat(); // Flatten the array of arrays
    };

    fetchItems(); // Call the function here
  }, []);

  return (
    <div className="about-us">
      <h1>About Us</h1>
      {items.map((folderItem) => (
        <div key={folderItem.folder}>
          <h2>{folderItem.folder}</h2>
          {folderItem.files.length > 0 ? (
            <div className="grid">
              {folderItem.files.map((file) => (
                <div className="grid-item" key={file.name}>
                  <a href={file.url} target="_blank" rel="noopener noreferrer">
                    <img src={file.url} alt={file.name} />
                  </a>
                  <p>Name: {file.name}</p>
                  <p>Size: {file.size} bytes</p>
                  <p>Type: {file.type}</p>
                </div>
              ))}
            </div>
          ) : (
            <p>No files found.</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default AboutUs;
